module.exports = __webpack_public_path__ + "img/DAI.8c2a021b.svg";